import { render, staticRenderFns } from "./CreditsTable.vue?vue&type=template&id=4faf65e6"
import script from "./CreditsTable.vue?vue&type=script&lang=js"
export * from "./CreditsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports